export const NOINDEX = 'noindex';
export const NOFOLLOW = 'nofollow';
export const NOINDEX_NOFOLLOW = 'noindex, nofollow';
export const NOARCHIVE = 'noarchive';
export const DISALLOW = 'disallow';
export const NONE = 'none';
